import { render, staticRenderFns } from "./njfb.vue?vue&type=template&id=1a838730&scoped=true&"
import script from "./njfb.vue?vue&type=script&lang=js&"
export * from "./njfb.vue?vue&type=script&lang=js&"
import style0 from "./njfb.vue?vue&type=style&index=0&id=1a838730&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a838730",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("K:\\website\\tmp\\2021.7-12\\mmlzcyy_project\\screen\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a838730')) {
      api.createRecord('1a838730', component.options)
    } else {
      api.reload('1a838730', component.options)
    }
    module.hot.accept("./njfb.vue?vue&type=template&id=1a838730&scoped=true&", function () {
      api.rerender('1a838730', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/page/mapDrawer/njfb.vue"
export default component.exports